var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table"},[_vm._t("default"),_c('Pagination',{attrs:{"params":_vm.params,"total":_vm.total},on:{"current-change":_vm.onCurrentChange,"size-change":_vm.onSizeChange}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }